
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv",
      function () {
        return require("private-next-pages/tv.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv"])
      });
    }
  